import React from 'react'

const Header = () => {
  return (
    <nav>Get Ready to Complete Your Daily Goals</nav>
  )
}

export default Header